import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLoadNewInvoicesOnMount } from '@fingo/lib/hooks';
import useIsMobile from '@fingo/lib/hooks/useIsMobile';
import DesktopNavbar from './navbar/DesktopNavbar';
import MobileNavbar from './navbar/MobileNavbar';
import SmallDesktopNavbar from './navbar/SmallDesktopNavbar';

const AppNavbar = () => {
  const location = useLocation();
  const isMobile = useIsMobile('md');
  const isSmallDesktop = useIsMobile('lg');
  useLoadNewInvoicesOnMount();

  const noNavbarRoutes = ['/user-register', '/user-login', '/simulator-register-video']; // to delete after QA of login form
  if (noNavbarRoutes.includes(location?.pathname)) return null;

  if (isMobile) return <MobileNavbar />;
  if (isSmallDesktop) return <SmallDesktopNavbar />;
  return <DesktopNavbar />;
};

export default AppNavbar;
